"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckRegionValues = exports.CheckRegion = void 0;
var CheckRegion;
(function (CheckRegion) {
    CheckRegion["US"] = "US";
    CheckRegion["EU"] = "EU";
})(CheckRegion = exports.CheckRegion || (exports.CheckRegion = {}));
exports.CheckRegionValues = Object.values(CheckRegion);
